import type { WorldBuilderResult } from '@creanizer/types'

interface WorldBasicInfoProps {
  result: WorldBuilderResult
}

export function WorldBasicInfo({ result }: WorldBasicInfoProps) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="font-semibold mb-2">概要</h3>
        <p className="text-sm">{result.summary}</p>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <h4 className="text-sm font-semibold mb-1">ジャンル</h4>
          <div className="flex flex-wrap gap-1">
            {result.genres.map((genre, index) => (
              <span
                key={index}
                className="px-2 py-1 text-xs bg-primary/10 text-primary rounded-md"
              >
                {genre}
              </span>
            ))}
          </div>
        </div>
        
        <div>
          <h4 className="text-sm font-semibold mb-1">世界の規模</h4>
          <p className="text-sm">{result.worldScale}</p>
        </div>
      </div>
      
      {result.details.era && (
        <div>
          <h3 className="font-semibold mb-2">時代設定</h3>
          <div className="space-y-2 p-3 bg-muted rounded-lg">
            <div>
              <span className="font-medium">{result.details.era.name}</span>
            </div>
            <p className="text-sm">{result.details.era.description}</p>
            <div className="text-sm space-y-1">
              <div>
                <span className="font-medium">技術レベル:</span> {result.details.era.technologyLevel}
              </div>
              <div>
                <span className="font-medium">社会構造:</span> {result.details.era.socialStructure}
              </div>
            </div>
          </div>
        </div>
      )}
      
    </div>
  )
}